/** Trigger a browser download for an in-memory Blob via a transient object URL. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/**
 * Force-download a CDN asset cross-origin without CORS. The private CDN worker
 * honors `?download=1&filename=...` by responding with
 * `Content-Disposition: attachment`, which makes the browser *save* (not open)
 * the file even though it's a different origin — so we just point an anchor at
 * the framed URL rather than `fetch`-ing the bytes (which CORS would block) or
 * opening a new tab (which a bare cross-origin `download` anchor does).
 *
 * The `download`/`filename` params are non-signed framing on the worker, so
 * appending them to an already-signed URL keeps the signature valid.
 */
export function downloadViaCdn(url: string, filename: string): void {
  let href = url;
  try {
    const u = new URL(url);
    u.searchParams.set("download", "1");
    u.searchParams.set("filename", filename);
    href = u.toString();
  } catch {
    // Non-absolute URL — fall back to the raw href; the anchor still tries.
  }
  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
